import Observer from "./observer.js"
import Util from "./util.js"

class ImageLoader extends Observer {
  constructor(){
    super()
  }

  data(){
    return {
      "loading": false,
      "loaded": false,
      "error": null,
      "image": null,
      "fileName": null
    }
  }

  changed(){
    return {
      "loaded": (val)=>{
        // console.log("image file " + this.fileName + " loaded")
      },
      "error": (val)=>{
        // console.log("load error")
      },
      "image": (val)=>{

      },
      "fileName": (val)=>{

      }
    }
  }

  register(fileName){
    if(typeof fileName !== "string"){
      return
    }
    this.$data.fileName = fileName
    if(this.$data.image === null){
      this.$data.image = new Image()
    }
  }

  get image(){
    return this.$data.image
  }

  get fileName(){
    return this.$data.fileName
  }

  async load(cache){
    let param = ""
    if(cache===false){
      param = "?" + Util.createGUID()
    }

    return new Promise((resolve, reject)=> {
      if(this.$data.loaded === true){
        this.dispatchEvent("loaded", true)
        resolve(this.$data.image)
      }else{
        //load image
        this.$data.image.onload = ()=>{
            this.$data.loaded = true
            resolve(this.$data.image)
          }
        this.$data.image.onerror = ()=>{
            this.$data.loaded = false
            if(this.$data.error === null){
              this.$data.error = "error"
            }else{
              this.dispatchEvent("error", "error")
            }
            reject()
          }
        this.$data.image.src = this.$data.fileName + param
      }
    })
  }
}

export default ImageLoader
